import React, { PureComponent } from 'react';
import { Chip } from '@material-ui/core';
import './chip.scss';

export class CommonChip extends PureComponent {
  constructor() {
    super();
    this.state = {
      selected: false,
    };
  }

  onDelete = () => {
    const { onDeleteChip, label } = this.props;
    onDeleteChip(label);
  };

  onHover = (selected) => () => {
    this.setState({
      selected,
    });
  };

  onClick = () => {
    const { onClick, label } = this.props;
    onClick(label);
  };

  render() {
    const { selected } = this.state;
    const {
      label,
      onDeleteChip,
      onClick,
      classes,
      showDelete = false,
    } = this.props;
    const deleteChip = onDeleteChip
      ? { onDelete: selected || showDelete ? this.onDelete : false }
      : {};
    const clickable = Boolean(onClick) ? { onClick: this.onClick } : {};
    const isPrimary = !Boolean(clickable) || (!selected && onDeleteChip);

    return (
      <Chip
        label={label}
        className={`chip${isPrimary ? '' : ' chip-hovered'} ${classes}`}
        variant="outlined"
        color={isPrimary ? 'primary' : 'default'}
        onMouseEnter={this.onHover(true)}
        onMouseLeave={this.onHover(false)}
        {...clickable}
        {...deleteChip}
      />
    );
  }
}

CommonChip.defaultProps = {
  classes: '',
  onDeleteChip: false,
  onClick: false,
};
